const qualifierCache = {};

export default qualifierCache;
